import * as React from 'react';
import TopNavigation from '../TopNavigation/TopNavigation';
import BottomNavigation from '../BottomNavigation/BottomNavigation';
import FollowUs from '../../common/FollowUs/FollowUs';
import CookiesPopup from '../../common/CookiesPopup/CookiesPopup';

const MainWrapper = ({ children }) => (
  <>
    <TopNavigation />
    {children}
    <FollowUs />
    <CookiesPopup />
    <BottomNavigation />
  </>
);

export default MainWrapper;
